import { VITE_USE_MOCK, VITE_MOCK_API, VITE_DIMS_CASE_VALIDATOR_API } from 'Constants/appEnvConstants'

export function getDimsCaseValidatorUrl() {
  // eslint-disable-next-line no-undef
  return JSON.parse(VITE_USE_MOCK) ? VITE_MOCK_API : VITE_DIMS_CASE_VALIDATOR_API;
}
